<template>
  <b-container>
    <b-card class="panel">
    <Loading :active.sync="Loading"></Loading>
    <div class="controles">
      <h2>Reporte por orden</h2>
    </div>
    <div>
      <b-form-input v-model="orden" placeholder="Introduzca la orden"></b-form-input> 
      <b-form-select class="select-tiempo" v-model="tiempo" :options="options"></b-form-select>
      <div v-if="tiempo === 1">
            <label for="datepicker-sm">Seleccione el día</label>
            <Vbdatapicker v-model="dia"  />
      </div>
      <div v-if="tiempo === 2">
            <label for="datepicker-sm">Seleccione la semana</label>
            <VbdatapickerWeek v-model="semana"  />
      </div>
      <div v-if="tiempo === 3">
            <label for="datepicker-sm">Seleccione el mes</label>
            <VbdatapickerMonth v-model="mes"  />
      </div>
      <div v-if="tiempo === 4"> 
            <label>Seleccione el año</label>
            <VbdatapickerYear v-model="anno"  />
      </div>
      <b-button class="generar"  @click="generar()">Generar</b-button>
    </div>   
   
      
    </b-card> 
    <b-card class="panel" v-if="arrData.length > 0">
               
        <div v-for="(item, index) in arrData" :key="index">
            <div v-for="(column, indexColumn) in maquina" :key="indexColumn">
                <h2>{{ nombreMaquina(column) }}</h2>
                <b-table :items="item[column]" :fields="fields"  outlined></b-table>
            </div>
        </div>
           
        

    </b-card> 
    <b-card class="panel"  v-else>
        <h2>Sin datos.</h2>
    </b-card> 
  </b-container>   
</template>

<script>
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'
    import {mapActions, mapState, mapGetters} from 'vuex'
    import _ from 'lodash'
    
    import Vbdatapicker from '@/components/partials/vbdatapicker'
    import VbdatapickerWeek from '@/components/partials/vbdatapickerWeek'
    import VbdatapickerMonth from '@/components/partials/vbdatapickerMonth'
    import VbdatapickerYear from '@/components/partials/vbdatapickerYear'
    import moment from 'moment'
     import customMixin from '@/mixins/customMixin'
    export default {
        name:'Orden',
         mixins : [customMixin],
        components:{
            Loading,Vbdatapicker, VbdatapickerWeek, VbdatapickerMonth, VbdatapickerYear
        },
        mounted(){
            this.init()
        },
        computed:{
            ...mapState(['Loading']),
            ...mapState('orden',['reporte']),

            
        },
        data:function () {
            return{
                maquina:[],
                tiempo: null,
                orden: null,
                options:[
                    {value: null, text: 'Seleccione la ventana de tiempo'},
                    {value: 1, text: 'Por día'},
                    {value: 2, text: 'Por semana'},
                    {value: 3, text: 'Por mes'},
                    {value: 4, text: 'Por año'},
                    ],
                dia:null,
                semana:null,
                mes:null,
                anno:null,
                arrData:[],
               
                fields:[
                    { key: 'Operador', label: 'Operador'},
                    
                    { key: 'Contador', label: 'Totales'},
                    
                    ]
            }            
        },
        methods:{
            ...mapActions({
                
                _fetchDia: 'orden/reporteDia',
                _fetchSemana: 'orden/reporteSemana',
                _fetchMes : 'orden/reporteMes',
                _fetchAnno: 'orden/reporteAnno'
            }),
            init(){
                
               
            },//init
            generar(){
                if(this.tiempo === 1){
                    this.porDia()
                }
                if(this.tiempo === 2){
                    this.porSemana()
                }
                if(this.tiempo === 3){
                    this.porMes()
                }
                if(this.tiempo === 4){
                    this.porAnno()
                }
            },
            porDia(){
                let payload = {
                    'orden':  this.orden,
                    'dia' : this.dia
                }
                this.arrData = []//se limpia
                this._fetchDia(payload).then(()=>{
                    let result = _.uniqBy(this.reporte,'Origen'); //se eliminan duplicados
                    let that = this 
                    this.maquina  = []//se limpia
                    _.forEach(result, function(value,key){
                        that.maquina.push(value.Origen) //se llena el vector con las maquinas
                    })
                    //se agrupa con respecto a las maquinas
                    this.arrData.push(  _.groupBy(this.reporte, function(value) {  
                        return value.Origen
                        })
                    )
                })
            },
            porSemana(){
                let payload = {
                    'orden':  this.orden,
                    'semana' : this.semana
                }
                this.arrData = []//se limpia
                this._fetchSemana(payload).then(()=>{
                    let result = _.uniqBy(this.reporte,'Origen'); //se eliminan duplicados
                    let that = this 
                    this.maquina  = []//se limpia
                    _.forEach(result, function(value,key){
                        that.maquina.push(value.Origen) //se llena el vector con las maquinas
                    })
                    //se agrupa con respecto a las maquinas
                    this.arrData.push(  _.groupBy(this.reporte, function(value) {  
                        return value.Origen
                        })
                    )
                })
            },
            porMes(){
                let mes = null
                let anno = null
                let partes = this.mes.toString().split(".")
                mes = partes[0]
                anno = partes[1]

                let payload = {
                    'orden':  this.orden,
                    'mes' : mes,
                    'anno' : anno
                }
                console.warn(payload)
                this.arrData = []//se limpia
                this._fetchMes(payload).then(()=>{
                    let result = _.uniqBy(this.reporte,'Origen'); //se eliminan duplicados
                    let that = this 
                    this.maquina  = []//se limpia
                    _.forEach(result, function(value,key){
                        that.maquina.push(value.Origen) //se llena el vector con las maquinas
                    })
                    //se agrupa con respecto a las maquinas
                    this.arrData.push(  _.groupBy(this.reporte, function(value) {  
                        return value.Origen
                        })
                    )
                })
            },
            porAnno(){
                let anno = moment(this.anno).year() 
                let payload = {
                    'orden':  this.orden,
                    'anno' : anno
                }
                this.arrData = []//se limpia
                this._fetchAnno(payload).then(()=>{
                    
                    let result = _.uniqBy(this.reporte,'Origen'); //se eliminan duplicados
                    let that = this 
                    this.maquina  = []//se limpia
                    _.forEach(result, function(value,key){
                        that.maquina.push(value.Origen) //se llena el vector con las maquinas
                    })
                    //se agrupa con respecto a las maquinas
                    this.arrData.push(  _.groupBy(this.reporte, function(value) {  
                        return value.Origen
                        })
                    )


                    
                })
            }
        }
        
    }
</script>

<style lang="scss" scoped>
.controles{
    display:flex;
    margin-top:1em;
    align-items: center;
}
h2{
    align-self:center;
    font-size: 1.5em;
    margin-bottom:0.5em;
}

.panel{
      margin-top:1em;
    }
.generar {
    margin-top:0.5em;
}
.select-operador{
    margin-top:0.5em;
}
.select-tiempo{
    margin-top:0.5em;
}
@media screen and (max-width: 576px) {
    .controles{
        flex-direction: column;
        padding:0;
        margin:0;
        
    }
    
}
</style>